import { render, staticRenderFns } from "./HomeFactory.vue?vue&type=template&id=4c75c6ba&scoped=true&"
import script from "./HomeFactory.vue?vue&type=script&lang=js&"
export * from "./HomeFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75c6ba",
  null
  
)

export default component.exports